import { isDevelopment } from '@quadminds/shared/utils';
import LogRocket from 'logrocket';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import './config/i18n';
import './styles.css';
import App from './app/app';
import { BASE_URL } from './config';
import { AuthProvider } from './context/AuthContext';

LogRocket.init('quadminds/users-landing', {
    network: {
        requestSanitizer: (request) => {
            // excludes user's credentials from being logged
            if (request.url.includes('accounts:signInWithPassword')) {
                (request.body as unknown) = null;
            }
            return request;
        },
    },
});

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (isDevelopment()) console.table(Object.entries(process.env));

root.render(
    <StrictMode>
        <BrowserRouter basename={BASE_URL}>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </QueryClientProvider>
        </BrowserRouter>
    </StrictMode>,
);
